<script>
import { notify } from '@/helpers/notify' 

import {
  required
} from "vuelidate/lib/validators";


export default {
    name: 'UpdateModal',
    props:[
        "data"
    ],
    data() {
        return {
            submitted: false,
            id:null,
            form:{
                fname:'',
                lname:'',
                username:''
            },
            ilList : [],
            bucakList:[],
            tariffList :[],
        };
    },
     validations: {
        form:{
            province : { required },
            township: { required },
            phonenumber: { required },   
            fname: { required },
            lname: { required },
        },
    }, 
    computed:{
        modalTitle(){ return  "Ön Başvuru Güncelle" },
    },  
    watch:{
        data(id){
            this.id = id
             this.$http.get(`members/${id}`)
                .then((response) =>this.form = response.data )
                .catch(error => error)
        },
    },
    mounted(){
        this.setSelected({ id : 0 },'il')
        this.getTariffList()
    },
    methods: { 
        save(){
            this.submitted = true;
            this.$v.form.$touch();
            if(this.$v.form.$invalid) return;
                this.$http.put(`members/kb_update`, { ...this.form, id:this.id, type:["service", "fullname", "contact"] })
                .then((resp) => notify.success(resp.data.message))
                .catch(error => error)
        },
     
  
        async getTariffList(){
            await this.$http.post('/tariff?output=one&fields=id,name')
            .then(resp => {
                this.tariffList = resp.data
            })
            .catch(error => error)
        },
        
        async setSelected(val,event){
            const object = event + 'List' 
            const { id } = val
            const response = await this.$http.post(`/address/${event}/${id}`)
            .catch(error => {
                // eslint-disable-next-line no-console
                console.log(error)
            })
            if(response.data.error) return;
            this[object] = response.data;
        },
        close(){
            this.$parent.$bvModal.hide('update_application_modal')
        }
    },
};
</script>

<template>
<b-modal id="update_application_modal"  :title="modalTitle"  no-close-on-backdrop hide-footer>
    <div class="row">
        <div class="col-md-12">
                <div class="alert alert-warning">
                {{ form.fname }}
                {{ form.lname }}
                <br>
                {{ form.username}}
            </div>
        </div>
    </div>  
    <form class="needs-validation">
        <div class="row d-flex flex-wrap mb-1"> 
            <label class="col-sm-4 col-form-label col-form-label" for="isim">İsim</label>
            <div class="col">
                <input
                id="identity_name"
                v-model="form.fname"
                type="text"
                class="form-control"
                placeholder="İsim"
                :class="{
                    'is-invalid': submitted && $v.form.fname.$error,
                }"
                />
                <div
                v-if="submitted && $v.form.fname.$error"
                class="invalid-feedback"
                >
                <span v-if="!$v.form.fname.required"
                    >Bu alanı doldurmak zorunludur.</span
                >
                </div>
            </div>
        </div>
        <div class="row d-flex flex-wrap mb-1">
            <label class="col-sm-4 col-form-label col-form-label" for="Soyisim">Soyisim</label>
            <div class="col">
                <input
                id="identity_last"
                v-model="form.lname"
                type="text"
                class="form-control"
                placeholder="Soyisim"
                
                :class="{
                    'is-invalid': submitted && $v.form.lname.$error,
                }"
                />
                <div
                v-if="submitted && $v.form.lname.$error"
                class="invalid-feedback"
                >
                <span v-if="!$v.form.lname.required"
                    >Bu alanı doldurmak zorunludur.</span
                >
                </div>
            </div>
        </div>
        <div class="row d-flex flex-wrap mb-1">
            <label class="col-sm-4 col-form-label col-form-label" for="phonenumber">Telefon Numarası</label>
            <div class="col">
                <input
                    id="phonenumber"
                    v-model="form.phonenumber"
                    type="text"
                    v-mask="'+(##)### ### ## ##'"
                    class="form-control"
                    placeholder="Telefon Numarası"
                    :class="{
                    'is-invalid': submitted && $v.form.phonenumber.$error,
                    }"
                />
                <div
                v-if="submitted && $v.form.phonenumber.$error"
                class="invalid-feedback"
                >
                <span v-if="!$v.form.phonenumber.required"
                    >Bu alanı doldurmak zorunludur.</span
                >
                </div>
            </div>
        </div>
        <div class="row d-flex flex-wrap mb-1">
            <label class="col-sm-4 col-form-label col-form-label" for="phonenumber2">Whatsapp</label>
            <div class="col">
                <input
                    id="phonenumber2"
                    v-model="form.phonenumber2"
                    type="text"
                    v-mask="'+(##)### ### ## ##'"
                    class="form-control"
                    placeholder="Whatsapp"
                />
            </div>
        </div>
        <div class="row d-flex flex-wrap mb-1" >
            <label class="col-sm-4 col-form-label col-form-label" for="email">E-Posta</label>
            <div class="col">
                <input
                id="email"
                v-model="form.email"
                type="text"
                class="form-control"
                placeholder="E-Posta"
                />
            </div>
        </div>
        <div class="row d-flex flex-wrap mb-1" >
            <label class="col-sm-4 col-form-label col-form-label" for="il">İlçe</label>
            <div class="col">
                <v-select
                    label="name" 
                    v-model="form.province"
                    :options="ilList" 
                    :reduce="country => country.id"
                    @option:selecting="setSelected($event,'bucak')"><span slot="no-options">Sonuç Bulunamadı</span>
                </v-select>
            </div>
        </div>
        <div class="row d-flex flex-wrap mb-1" >
            <label class="col-sm-4 col-form-label col-form-label" for="bolge">Bölge</label>
            <div class="col">
                <v-select 
                label="name"  
                v-model="form.township"                    
                :options="bucakList" 
                :reduce="country => country.id"><span slot="no-options">Sonuç Bulunamadı</span>
                </v-select>
            </div>
        </div>
        <div class="row d-flex flex-wrap mb-1" >
            <label class="col-sm-4 col-form-label col-form-label" for="address">Adres</label>
            <div class="col">
                <input
                    id="address" 
                    v-model="form.address"
                    type="text"
                    class="form-control"
                    placeholder="Adres Açıklaması"
                />
            </div>
        </div>
        <div class="row d-flex flex-wrap mb-1" >
            <label class="col-sm-4 col-form-label col-form-label" for="adress">Servis</label>
            <div class="col">
                <v-select 
                    v-model="form.tariff_id"
                    :options="tariffList"
                    :reduce="r => r.id"
                    label="name"
                    >
                <span slot="no-options">Sonuç Bulunamadı</span>
                </v-select>
            </div>
        </div>
        <div class="d-flex justify-content-between mt-3">
            <button class="btn btn-light" type="button" @click="close()">Vazgeç</button>
            <button class="btn btn-primary" type="button" @click="save()">Güncelle</button>
        </div>
    </form>
</b-modal>
</template>